<style>
</style>

<template>
  <div>
    <div
      class="fixed_bottom_basket plr"
      v-if="$store.getters.selectedProducts.length > 0 || page === 'receipt'"
    >
      <template
        v-if="page === 'receipt' && $store.getters.totalOnlyProductsNoDiscount < $store.getters.outletSettings.order_from"
      >
        <a class="fbb_btn fbb_btn_disable">
          {{ buttonText }}
          <i :class="{ 'ios-font': $store.getters.checkIos }" v-html="$options.filters.toCurrency($store.getters.totalPrice)"></i>
        </a>
      </template>
      <a @click="next()" class="fbb_btn" v-else>
        {{ buttonText }}
        <i :class="{ 'ios-font': $store.getters.checkIos }" v-html="$options.filters.toCurrency($store.getters.totalPrice)"></i>
      </a>
    </div>
    <!--  basket mode when page = 'count'  -->
    <transition name="fade">
      <div
        :key="'count_dark_' + page"
        class="pu_dark"
        v-if="$store.getters.modal.count && $store.getters.currentProduct"
      ></div>
    </transition>
    <transition name="slide">
      <BasketCount
        :key="'count_' + page"
        v-show="$store.getters.modal.count"
        :alreadySelected="alreadySelected"
        :count.sync="count"
        :weight.sync="weight"
        :page="page"
        :weight="weight"
        v-if="$store.getters.outletSettings.delivery_type !== 4"
      ></BasketCount>
    </transition>
    <!--  basket mode when page = 'count' end -->
  </div>
</template>

<script>
  import BasketCount from '@/components/Default/Basket/Count.vue'
  import {SET_LOADING, SET_MODAL} from '@/store/mutations.type'
  import {MAKE_ORDER} from '@/store/actions.type'

  export default {
    name: 'Basket',
    components: {
      BasketCount
    },
    props: {
      page: String
    },
    data() {
      return {
        weight: 0,
        count: 1,
        loaded: false,
        alreadySelected: false,
        basketNextRoute: 'receipt'
      }
    },
    watch: {
      $route: {
        handler: function (route) {
          let time = 100

          if (route.name === 'home' && this.basketNextRoute !== 'receipt') {
            setTimeout(() => {
              this.basketNextRoute = 'receipt'
            }, time)
          }
          if (route.name === 'receipt' && this.basketNextRoute !== 'form') {
            setTimeout(() => {
              this.basketNextRoute = 'form'
            }, time)
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      this.loadCurrentProduct()

      this.$store.subscribe(mutation => {
        if (mutation.type === SET_MODAL && mutation.payload.modal === 'count') {
          if (mutation.payload.status === true) {
            this.loaded = false
            this.alreadySelected = false
            this.count = 1
            this.weight = 0
            this.loadCurrentProduct()
          } else {
          }
        }
      })
    },
    methods: {
      next() {
        if (
          this.basketNextRoute === 'form' &&
          this.$store.getters.upsell.length > 0
        ) {
          return this.$store.commit(SET_MODAL, {modal: 'upsell', status: true})
        }
        if (
          this.basketNextRoute === 'form' &&
          this.$store.getters.enableOrder &&
          this.$store.getters.contactlessMode &&
          !this.$store.getters.enableOnlinePayment
        ) {
          this.$store.dispatch(MAKE_ORDER, {})
        } else {
          return this.$router.push({
            name: this.basketNextRoute,
            params: {token: this.$store.getters.token}
          })
        }
      },

      isDelivery() {
        return this.$store.getters.outletSettings.delivery_type === 3
      },

      loadCurrentProduct() {
        if (this.loaded) {
          return
        }

        let currentProduct = this.$store.getters.currentProduct
        let selectedProducts = this.$store.getters.selectedProducts

        if (!currentProduct) {
          return
        }

        for (let i = 0; i < selectedProducts.length; i++) {
          const product = selectedProducts[i]
          if (product.id === currentProduct.id) {
            this.alreadySelected = true
            this.count = product.count
            this.weight = product.count
            this.loaded = true
          }
        }
      }
    },
    computed: {
      remainToOrder() {
        return (
          this.$store.getters.outletSettings.order_from -
          this.$store.getters.totalPrice
        )
      },
      buttonText() {
        let text = this.text('bottom_button_to_basket')
        if (this.page === 'receipt' || this.$store.getters.totalPrice === 0 || this.$store.getters.enableOnlinePayment) {
          text = this.text('bottom_button_to_form_basket')
        }
        if (
          this.$route.name === 'receipt' &&
          this.$store.getters.contactlessMode &&
          !this.$store.getters.enableOnlinePayment
        ) {
          text = this.text('screen_form_cashback_make_order')
        }
        return text
      }
    }
  }
</script>
